<template>  
  <div class="custom-tooltip-wrapper">  
    <div class="trigger-box">
      <slot name="trigger"  @mouseover="visible = true" @mouseleave="visible = false" ></slot> <!-- 插槽用于传入触发Tooltip的元素 -->  
    </div>
    <div class="custom-tooltip">  
      <slot name="content"></slot> <!-- 插槽用于传入Tooltip的内容 -->  
      <div class="tooltip-arrow"></div>  <!-- 箭头 -->
    </div>  
  </div>  
</template>  
  
<script>  
export default {  
  name: 'CustomTooltip',  
  data() {  
    return {  
      visible: false, // 控制Tooltip的显示与隐藏  
    };  
  }
};  
</script>  
  
<style lang="scss" scoped>  
.custom-tooltip-wrapper {  
  position: relative;  
  display: inline-block; /* 确保wrapper能够围绕内容展开 */  

  .trigger-box{
    position: relative;
    z-index:10;
    left: 50%;
    transform: translateX(-50%); /* 居中显示 */  
  }

  .custom-tooltip {  
    position: absolute;  
    z-index:9;
    max-width: 616px;
    width: calc(100vw - 80px);
    min-height: 158px;
    left: 50%;
    transform: translate(-50%,-90%); /* 居中显示 */  

    background-color: transparent;  
    border: 1px solid #FFFFFF;
    backdrop-filter: blur(5px);
    border-radius: 20px;  
    opacity: 0;
    transition: opacity 0.5s ease,transform 0.5s ease;  
    pointer-events: none; /* 防止鼠标事件穿透 */  
    padding: 24px 28px;

    font-weight: 400;
    font-size: 14px;
    color: #FFFFFF;
    letter-spacing: 0;
    text-align: justify; 
    line-height: 22px;
  }
  .tooltip-arrow {  
    position: absolute;  
    width: 0;  
    height: 0; 
    border-color: white transparent transparent  transparent;  
    border-width: 8px;
	  border-style: solid; 
    bottom: -16px;
    left: 50%;  
    transform: translateX(-50%); 

    &::after{ //中间空心
      position: absolute;
      content: '';
      border-top:  8px solid #000000 ; 
      border-left: 8px solid transparent;  
      border-right: 8px solid transparent; 
      bottom: 2px;
      left: 50%;  
      transform: translateX(-50%); 
    }
  }
}  
  
.custom-tooltip-wrapper:hover .custom-tooltip {  
  opacity: 1;  
  // top:-183px;
  transform: translate(-50%, calc(-100% - 25px));
}  
</style>